export default __webpack_public_path__ + "34b275e3117edce2114cf5701fed3e28.png";